import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import GoogleMap from './GoogleMap';
import authService from './api-authorization/AuthorizeService';
import GoogleMapDunny from './GoogleMapsDunny';

interface AllocateMap {
    scheduleDate: any;
    routes: ScheduleRoutes[];
    loading: boolean;
}

interface ScheduleRoutes {
    orderManual: string;
    jobAddresses: JobAddress[]
}

interface JobAddress {
    orderManual: string;
    jobOrder: number;
    placeId: string;
    address: string;
    lat: number;
    lng: number;
    colourId: number;       //used to display a green, orange or red pin
}

interface INameToValueMap {
    [key: string]: any;
}

export class AllocateMapData extends React.Component<RouteComponentProps<{}>, AllocateMap> {
    constructor(props: any) {
        super(props);

        this.state = {
            scheduleDate: "",
            routes: [],
            loading: true
        };
 
    }

    componentDidMount() {
        let mapParams: INameToValueMap = {};
        mapParams = this.props.match.params;
        let date = mapParams["scheduleDate"];
        this.setState({ scheduleDate: date });

        this.getAllocateAddresses(date);
    }

    async getAllocateAddresses(date: string) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Allocate/GetAllocatingItemAddresses?SubId=' + user.sub + '&ScheduleDate=' + date, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            let routes = res.data;

            this.setState({ routes: routes, loading: false })
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    async getAllocateAddressesDunny(date: string) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser(); 

        axios.get('api/Allocate/GetAddressFencingToiletForAllocating?SubId=' + user.sub + '&ScheduleDate=' + date, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                var routes: ScheduleRoutes[] = [];
                var item: ScheduleRoutes = {
                    orderManual: "1",
                    jobAddresses: res.data
                };
                routes.push(item);

                this.setState({ routes: routes, loading: false })
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let map = <GoogleMap routes ={this.state.routes} />
        //let map = <GoogleMapDunny routes={this.state.routes } />

        return (
            <div>
                
                <div className="row">
                    {map}
                </div>

            </div>
        );

    }

};

